module.exports = __webpack_public_path__ + "site/img/21.fb360bd4.jpg";